module.exports = __webpack_public_path__ + "img/scrollTo-hover.513c87dc.svg";